import React from 'react';
import ReactDOM from 'react-dom/client';
import {ThemeProvider, CssBaseline} from '@mui/material';
import './index.css';
import App from './App';
import theme from './theme';
import reportWebVitals from './reportWebVitals';

// ThemeProvider wraps the whole app so every MUI component picks up the
// brand palette. CssBaseline applies the theme background to <body> and
// normalizes default browser styles.
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <App />
    </ThemeProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
